"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[39486],{

/***/ 360339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": function() { return /* binding */ SOCKET_ATTRIBUTE_GROUPS_ID; },
/* harmony export */   "Bf": function() { return /* binding */ CPU_SOCKET_ATTRIBUTE_CODE; },
/* harmony export */   "DT": function() { return /* binding */ DEFAULT_PRICE_FILTER; },
/* harmony export */   "Gp": function() { return /* binding */ MAIN_BOARD_CATEGORY_ID; },
/* harmony export */   "U8": function() { return /* binding */ BUILDPC_V3_LOCAL_STORAGE_KEY; },
/* harmony export */   "aJ": function() { return /* binding */ BUILD_PC_MODAL_PAGE_SIZE; },
/* harmony export */   "rY": function() { return /* binding */ CPU_CATEGORY_ID; },
/* harmony export */   "t5": function() { return /* binding */ MAIN_BOARD_SOCKET_ATTRIBUTE_CODE; }
/* harmony export */ });
/* unused harmony exports CPU_CATEGORY_NAME, MAIN_BOARD_CATEGORY_NAME */
const BUILDPC_V3_LOCAL_STORAGE_KEY = "buildPc3";
const BUILD_PC_MODAL_PAGE_SIZE = 20;
const DEFAULT_PRICE_FILTER = {
    gte: 0,
    lte: 1000000000
};
const CPU_CATEGORY_ID = "553";
const MAIN_BOARD_CATEGORY_ID = "552";
const CPU_CATEGORY_NAME = "CPU";
const MAIN_BOARD_CATEGORY_NAME = "MAINBOARD";
const SOCKET_ATTRIBUTE_GROUPS_ID = [
    6199,
    8360
];
const CPU_SOCKET_ATTRIBUTE_CODE = "attributes.cpu_socket";
const MAIN_BOARD_SOCKET_ATTRIBUTE_CODE = "attributes.mainboard_socket";


/***/ }),

/***/ 39486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BuildPCV2Provider; },
/* harmony export */   "s": function() { return /* binding */ useBuildPCV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(775002);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(535820);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88837);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(420577);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(360339);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(329040);
/* harmony import */ var _ServiceContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(643015);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(634655);
/* harmony import */ var _ToastContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(508285);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};










const initialState = {
    loading: false,
    buildPCData: {
        configs: [
            {},
            {},
            {}
        ],
        activeIndex: 0,
        currentConfig: {}
    },
    buildPCDetailProducts: {
        products: [],
        filters: {},
        pagination: {
            totalItems: 0,
            totalPages: 0
        }
    },
    changeActiveConfig: ()=>{},
    increaseHardwareQuantity: ()=>{},
    decreaseHardwareQuantity: ()=>{},
    setHardwareQuantity: ()=>{},
    addHardware: ()=>{},
    removeHardware: ()=>{},
    updateCurrentConfig: ()=>{},
    onUpdateConfig: ()=>Promise.resolve(),
    mappedPrintBuildPCData: {},
    estimatedAmount: 0
};
const BuildPCV2Context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(initialState);
const BuildPCV2Provider = (param)=>{
    let { children ,  } = param;
    const { discoveryServiceV2  } = (0,_ServiceContext__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const { buildPcMapping  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const toast = (0,_ToastContext__WEBPACK_IMPORTED_MODULE_5__/* .useToast */ .p)();
    const { 0: lsBuildPCData , 1: setLsBuildPCData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getLocalConfigs */ .YM)());
    const buildPCData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return _objectSpreadProps(_objectSpread({}, lsBuildPCData), {
            currentConfig: lsBuildPCData.configs[lsBuildPCData.activeIndex]
        });
    }, [
        lsBuildPCData
    ]);
    // update all local storage config when current config changes
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        localStorage.setItem(constants_index__WEBPACK_IMPORTED_MODULE_7__/* .BUILDPC_V3_LOCAL_STORAGE_KEY */ .U8, JSON.stringify(lsBuildPCData));
    }, [
        lsBuildPCData
    ]);
    // get all skus from current active config
    const currentConfigSkus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const skus = [];
        Object.keys(buildPCData.currentConfig).forEach((configKey)=>{
            var ref;
            if (!!((ref = buildPCData.currentConfig[configKey]) === null || ref === void 0 ? void 0 : ref.sku) && !skus.includes(buildPCData.currentConfig[configKey].sku)) {
                skus.push(buildPCData.currentConfig[configKey].sku);
            }
        });
        return skus;
    }, [
        buildPCData.currentConfig
    ]);
    // call api search-skus-v2 to get all current active config skus detail info
    const { result: buildPCDetailProducts , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_8__/* .useSearch */ .Rx)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_9__.cleanObject)(!!currentConfigSkus.length ? {
        pageSize: currentConfigSkus.length,
        filter: {
            skus: currentConfigSkus
        }
    } : {}));
    // Check if current active config is empty or not
    const isCurrentConfigEmpty = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return Object.keys(buildPCData.currentConfig).length === 0;
    }, [
        buildPCData.currentConfig
    ]);
    // Calculate total price of all products in current config
    const estimatedAmount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (isCurrentConfigEmpty) {
            return 0;
        }
        return Object.keys(buildPCData.currentConfig).reduce((total, current)=>{
            const lsHardware = buildPCData.currentConfig[current];
            if (!!lsHardware && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .isEmptyObject */ .Q)(lsHardware)) {
                var ref, ref1;
                const hardwareDetail = buildPCDetailProducts.products.find((product)=>{
                    return product.sku === lsHardware.sku;
                });
                const quantity = lsHardware.quantity || 0;
                const price = (hardwareDetail === null || hardwareDetail === void 0 ? void 0 : (ref = hardwareDetail.price) === null || ref === void 0 ? void 0 : ref.latestPrice) || (hardwareDetail === null || hardwareDetail === void 0 ? void 0 : (ref1 = hardwareDetail.price) === null || ref1 === void 0 ? void 0 : ref1.price) || 0;
                return total + price * quantity;
            }
            return total;
        }, 0);
    }, [
        buildPCData.currentConfig,
        isCurrentConfigEmpty,
        buildPCDetailProducts
    ]);
    // Map print data to match interface of PrintBuildPc component
    const mappedPrintBuildPCData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return Object.keys(buildPCData.currentConfig).reduce((result, currentKey)=>{
            const lsHardware = buildPCData.currentConfig[currentKey];
            const productData = buildPCDetailProducts.products.find((product)=>{
                return product.sku === (lsHardware === null || lsHardware === void 0 ? void 0 : lsHardware.sku);
            });
            if (!!productData && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .isEmptyObject */ .Q)(productData)) {
                result[currentKey] = {
                    product: productData,
                    quantity: lsHardware.quantity
                };
            }
            return result;
        }, {});
    }, [
        buildPCData.currentConfig,
        buildPCDetailProducts
    ]);
    const changeActiveConfig = (activeIndex)=>{
        setLsBuildPCData(_objectSpreadProps(_objectSpread({}, lsBuildPCData), {
            activeIndex
        }));
    };
    const increaseHardwareQuantity = (hardwareType)=>{
        setLsBuildPCData(_objectSpreadProps(_objectSpread({}, lsBuildPCData), {
            configs: lsBuildPCData.configs.map((config, index)=>{
                // check if config is the active config
                if (lsBuildPCData.activeIndex === index) {
                    return _objectSpreadProps(_objectSpread({}, config), {
                        [hardwareType]: _objectSpreadProps(_objectSpread({}, config[hardwareType]), {
                            quantity: config[hardwareType].quantity + 1
                        })
                    });
                }
                return config;
            })
        }));
    };
    const decreaseHardwareQuantity = (hardwareType)=>{
        setLsBuildPCData(_objectSpreadProps(_objectSpread({}, lsBuildPCData), {
            configs: lsBuildPCData.configs.map((config, index)=>{
                // check if config is the active config
                if (lsBuildPCData.activeIndex === index) {
                    // decrease the hardware type quantity
                    return _objectSpreadProps(_objectSpread({}, config), {
                        [hardwareType]: _objectSpreadProps(_objectSpread({}, config[hardwareType]), {
                            quantity: config[hardwareType].quantity - 1
                        })
                    });
                }
                return config;
            })
        }));
    };
    const setHardwareQuantity = (hardwareType, quantity)=>{
        // stop when input quantity is 0
        if (!quantity) {
            return;
        }
        setLsBuildPCData(_objectSpreadProps(_objectSpread({}, lsBuildPCData), {
            configs: lsBuildPCData.configs.map((config, index)=>{
                // check if config is the active config
                if (lsBuildPCData.activeIndex === index) {
                    return _objectSpreadProps(_objectSpread({}, config), {
                        [hardwareType]: _objectSpreadProps(_objectSpread({}, config[hardwareType]), {
                            quantity
                        })
                    });
                }
                return config;
            })
        }));
    };
    const addHardware = (hardwareType, hardwareData)=>{
        setLsBuildPCData(_objectSpreadProps(_objectSpread({}, lsBuildPCData), {
            configs: lsBuildPCData.configs.map((config, index)=>{
                // check if config is the active config
                if (lsBuildPCData.activeIndex === index) {
                    // check if the new hardware is already existed in active config
                    if (!(0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .isEmptyObject */ .Q)(config[hardwareType]) && config[hardwareType].sku === hardwareData.sku) {
                        //if yes, increase its quantity
                        return _objectSpreadProps(_objectSpread({}, config), {
                            [hardwareType]: _objectSpreadProps(_objectSpread({}, config[hardwareType]), {
                                quantity: config[hardwareType].quantity + 1
                            })
                        });
                    }
                    // if not, update the hardware type with new hardware
                    return _objectSpreadProps(_objectSpread({}, config), {
                        [hardwareType]: hardwareData
                    });
                }
                return config;
            })
        }));
    };
    const removeHardware = (hardwareType)=>{
        setLsBuildPCData(_objectSpreadProps(_objectSpread({}, lsBuildPCData), {
            configs: lsBuildPCData.configs.map((config, index)=>{
                // check if config is the active config
                if (lsBuildPCData.activeIndex === index) {
                    const { [hardwareType]: _  } = config, remainingConfig = _objectWithoutProperties(config, [
                        hardwareType
                    ].map(_toPropertyKey));
                    return remainingConfig;
                }
                return config;
            })
        }));
    };
    const updateCurrentConfig = (newConfig)=>{
        // since this function will be used in a component outside the provider
        // buildpc state won't be the same --> we'll use buildpc data from localstorage instead.
        const lsData = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getLocalConfigs */ .YM)();
        setLsBuildPCData(_objectSpreadProps(_objectSpread({}, lsData), {
            configs: lsData.configs.map((config, index)=>{
                // check if config is the active config
                if (lsData.activeIndex === index) {
                    // replace with new config
                    return newConfig;
                }
                return config;
            })
        }));
    };
    const onUpdateConfig = async (product)=>{
        var ref;
        if (!((ref = product.materials) === null || ref === void 0 ? void 0 : ref.length) || !buildPcMapping || (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .isEmptyObject */ .Q)(buildPcMapping)) {
            var ref1;
            toast === null || toast === void 0 ? void 0 : (ref1 = toast.error) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Sản phẩm n\xe0y kh\xf4ng hỗ trợ chỉnh sửa cấu h\xecnh"),
                message: ""
            });
            return;
        }
        try {
            // get all material skus of current product
            const materialSkus = product.materials.map((material)=>material.sku);
            // call api search-skus-v2 to get materials categories for mapping
            const data = await discoveryServiceV2.search({
                pageSize: materialSkus.length,
                filter: {
                    skus: materialSkus
                }
            });
            const materialProducts = data.products;
            // Get all mapping keys from buildPcMapping
            const buildPCMappingKeys = !!buildPcMapping && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .isEmptyObject */ .Q)(buildPcMapping) ? Object.keys(buildPcMapping) : [];
            // Create new buildpc config from product's materials & buildpc mapping keys
            const newConfig = buildPCMappingKeys.reduce((config, currentKey)=>{
                // Get defined buildpc mapping categories from tenant config
                const currentMappingCategories = buildPcMapping[currentKey].categories;
                materialProducts === null || materialProducts === void 0 ? void 0 : materialProducts.forEach((materialProduct)=>{
                    var ref;
                    // Check if any categories from materialProducts included in current key mapping categories
                    const matchedCategory = (ref = materialProduct.categories) === null || ref === void 0 ? void 0 : ref.find((category)=>{
                        return currentMappingCategories.find((mappingCategory)=>{
                            return mappingCategory === category.code;
                        });
                    });
                    // if exists, add material sku & quantity to new config
                    if (!!matchedCategory && !!materialProduct.sku) {
                        var ref1;
                        // find material quantity in product's materials by sku
                        const matchedMaterial = (ref1 = product.materials) === null || ref1 === void 0 ? void 0 : ref1.find((material)=>material.sku === materialProduct.sku);
                        if (!!matchedMaterial) {
                            config[currentKey] = {
                                sku: materialProduct.sku,
                                quantity: matchedMaterial.quantity
                            };
                        }
                    }
                });
                return config;
            }, {});
            if (!(0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .isEmptyObject */ .Q)(newConfig)) {
                updateCurrentConfig(newConfig);
            }
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuildPCV2Context.Provider, {
        value: {
            loading: isLoading,
            buildPCData,
            buildPCDetailProducts,
            changeActiveConfig,
            increaseHardwareQuantity,
            decreaseHardwareQuantity,
            setHardwareQuantity,
            addHardware,
            removeHardware,
            updateCurrentConfig,
            onUpdateConfig,
            mappedPrintBuildPCData,
            estimatedAmount
        },
        children: children
    });
};
const useBuildPCV2 = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BuildPCV2Context);
    if (!context) {
        throw new Error("useBuildPCV2 must be inside a BuildPCV2Provider with a state value");
    }
    return context;
};


/***/ }),

/***/ 329040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ou": function() { return /* binding */ getDisplayFilter; },
/* harmony export */   "YM": function() { return /* binding */ getLocalConfigs; },
/* harmony export */   "pu": function() { return /* binding */ convertFilter; }
/* harmony export */ });
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(775002);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(535820);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(679376);
/* harmony import */ var _constants_buildpc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(360339);


const getDisplayFilter = (filters)=>{
    return filters.filter((filter)=>{
        var ref;
        return (filter === null || filter === void 0 ? void 0 : (ref = filter.options) === null || ref === void 0 ? void 0 : ref.length) && filter.options.length > 1;
    });
};
const convertFilter = (filters)=>{
    const convertedFilters = {};
    const attributes = new Map();
    filters.forEach((filter)=>{
        if (filter.filterCode && filter.optionId) {
            // attributes
            if (filter.filterCode.startsWith("attributes.")) {
                const attributeCode = filter.filterCode.replace("attributes.", "");
                const attributesValue = attributes.get(attributeCode);
                if (attributesValue) {
                    attributes.set(attributeCode, [
                        ...attributesValue,
                        filter.optionId.toString(), 
                    ]);
                } else {
                    attributes.set(attributeCode, [
                        filter.optionId.toString()
                    ]);
                }
            // others
            } else {
                const attributesValue1 = convertedFilters[filter.filterCode];
                if (attributesValue1) {
                    convertedFilters[filter.filterCode] = [
                        ...attributesValue1,
                        filter.optionId.toString(), 
                    ];
                } else {
                    convertedFilters[filter.filterCode] = [
                        filter.optionId.toString()
                    ];
                }
            }
        }
    });
    if (attributes.size > 0) {
        convertedFilters["attributes"] = Array.from(attributes, (param)=>{
            let [code, optionIds] = param;
            return {
                code,
                optionIds
            };
        });
    }
    return (0,_teko_utils__WEBPACK_IMPORTED_MODULE_0__.cleanObject)(convertedFilters);
};
const getLocalConfigs = ()=>{
    let result = {
        configs: [
            {},
            {},
            {}
        ],
        activeIndex: 0
    };
    const lsBuildPcLocalConfigs =  true ? localStorage.getItem(_constants_buildpc__WEBPACK_IMPORTED_MODULE_1__/* .BUILDPC_V3_LOCAL_STORAGE_KEY */ .U8) : 0;
    if (!!lsBuildPcLocalConfigs && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_2__/* .isEmptyObject */ .Q)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJsonStringSafely */ .O)(lsBuildPcLocalConfigs))) {
        result = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJsonStringSafely */ .O)(lsBuildPcLocalConfigs);
    }
    return result;
};


/***/ })

}]);